module.exports = __webpack_public_path__ + "img/mail-3.a2c1b13a.svg";